import { Actions } from './forms.actions'
import { fromJS } from 'immutable'
import * as FormsTypes from './forms.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    filtered: 0,
  },
  createForm: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      form: [
        {
          label: 'Property Type',
          index: 0,
          name: 'propertytype',
          isMultiple: false,
          isPropertyType: true,
          type: 'select',
          options: [],
        },
      ],
    },
  },
  updateForm: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function formsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case FormsTypes.UPDATE_FORM_REQUEST: {
      return state.setIn(['updateForm', 'isLoading'], true)
    }

    case FormsTypes.UPDATE_FORM_SUCCESS: {
      return state.setIn(['updateForm', 'isLoading'], false)
    }

    case FormsTypes.UPDATE_FORM_FAILURE: {
      return state.setIn(['updateForm', 'isLoading'], false)
    }

    case FormsTypes.CREATE_FORM_REQUEST: {
      return state.setIn(['createForm', 'isLoading'], true)
    }

    case FormsTypes.CREATE_FORM_SUCCESS: {
      return state.setIn(['createForm', 'isLoading'], false)
    }

    case FormsTypes.CREATE_FORM_FAILURE: {
      return state.setIn(['createForm', 'isLoading'], false)
    }

    case FormsTypes.DELETE_FORM_REQUEST: {
      return state
    }

    case FormsTypes.DELETE_FORM_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case FormsTypes.DELETE_FORM_FAILURE: {
      return state
    }

    case FormsTypes.FETCH_FORMS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case FormsTypes.FETCH_FORMS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'filtered'], fromJS(action.filtered))
    }

    case FormsTypes.FETCH_FORMS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case FormsTypes.FETCH_FORM_REQUEST: {
      return state.setIn(['updateForm', 'isLoading'], true)
    }

    case FormsTypes.FETCH_FORM_SUCCESS: {
      return state
        .setIn(['updateForm', 'isLoading'], false)
        .setIn(['updateForm', 'data'], fromJS(action.payload))
    }

    case FormsTypes.FETCH_FORM_FAILURE: {
      return state.setIn(['updateForm', 'isLoading'], false)
    }

    case FormsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case FormsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
